export default import.meta.ROLLDOWN_FILE_URL_DUA2tiisjIeXzZF24PX2uA